import { DataFiltersSection } from "@/components/molecules/ManualWidgetForm";
import type { DraftDataFilter } from "@/modules/widgets/types/dataFilters";
import type { ClarificationFilterFieldOption } from "./types";

interface FilterInputProps {
    drafts: DraftDataFilter[];
    fieldOptions: ClarificationFilterFieldOption[];
    isOpen: boolean;
    onToggleOpen: () => void;
    onChange: (drafts: DraftDataFilter[]) => void;
}

export function FilterInput({ drafts, fieldOptions, isOpen, onToggleOpen, onChange }: FilterInputProps) {
    return (
        <>
            <DataFiltersSection
                filters={drafts}
                fieldOptions={fieldOptions}
                isOpen={isOpen}
                onToggleOpen={onToggleOpen}
                onChange={onChange}
            />
            {drafts.some((f) => f.error) && (
                <ul className="mt-2 space-y-1 text-[11px] text-[#d14343]">
                    {drafts.map((f, i) => f.error ? <li key={i}>{f.error}</li> : null)}
                </ul>
            )}
        </>
    );
}
